
import { ApiService } from "./api.service";
import moment from "moment";
import { AppIcons } from "../constants/app-icons";
import { DOMAIN } from "./domain-constant";
export default class MessageTemplate extends ApiService {
  namespace = "message-template";
  icon = "Announcement";
  name = "Type";
  favicon = "Template";
  template = "defaultTemplate";
  relations = "";
  singular = this.terminology.messageTemplate.singular;
  plural = this.terminology.messageTemplate.plural;
  vowel = this.terminology.messageTemplate.vowel;
  name = `${this.vowel} ${this.singular}`;
  Width = 1100;
  DOMAIN = DOMAIN.MESSAGE_TEMPLATE;
  action = "action";
  navItems = [
    {
      key: "active",
      label: this.t("viewActiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.ENABLED,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },

  ];
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: this.t("subject"),
      icon: AppIcons.TAG,
      field: "subject",
    },

    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return moment.unix(data.created_at).format("MM/DD/YYYY");
      },
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a message template",
      icon: AppIcons.PLUS,
    },
  ];
  // filterItems = [];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit an Employee",
        icon: AppIcons.EDIT,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
    ];
    return listMenuItems;
  }
  constructor() {
    super("message-templates");
  }
}
